<template>
  <div class="block-next-luckyday">
    <div class="wrap">
      <div class="inner">
        <img class="head-luckyday" src="/static/img/recommend/lp/kurenotori/products/head_next_luckyday.png" alt="">
        <span class="luckyday" v-html="nextLuckyDayStr"></span>
        <span class="under-line"></span>
        <div class="description" v-html="resultData.text2"></div>
        <p class="notice">※「注目の幸運日」は、日付が連続する場合がございますが、占術を忠実に再現しているために起こります。不具合ではございませんのでご安心ください</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockNextLuckyDay',
  props: {
    resultData: {
      type: Object,
      required: true,
    }
  },
  computed: {
    nextLuckyDayStr() {
      const mtc = this.resultData.datetime.match(/(\d{4})(?:年|-)(\d+)(?:月|-)(\d+)日?/)
      const dt = !!mtc ? moment([+mtc[1],+mtc[2]-1, +mtc[3]]) : null
      return !!dt ? `<span class="grad">${dt.format('YYYY')}年</span><span class="grad">${dt.format('M')}月</span><span class="grad">${dt.format('D')}日</span>` : 'ああ'
    },
  }

}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$basic_gradient: linear-gradient(270deg, #5beae8 0%, #537fe4 100%);

.block-next-luckyday {
  padding: 0 20px;
  position: relative;
  overflow: hidden;
  .wrap {
    .inner {
      background: white;
      padding: 30px 20px 32px;
      border: 1px solid var(--key-color);
      border-radius: 10px;
      text-align: center;
      @include mq('w580') {
        padding: 48px 32px 40px;
      }
    }
  }

  /deep/ .grad {
    display: inline-block;
    background: $basic_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .head-luckyday {
    display: block;
    margin-bottom: 20px;
  }

  .luckyday{
    display: inline-block;
    //background: -webkit-gradient(linear, right top, left top, from(#5beae8), to(#537fe4));
    background: $basic_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
    font-size: 26px;
    margin-bottom: 4px;
  }
  .under-line {
    width: 82.3%;
    height: 2px;
    margin: auto;
    display: block;
    background: $basic_gradient;
    margin-bottom: 24px;
  }
  .description {
    text-align: left;
    background: url(/static/img/recommend/lp/kurenotori/products/img_next_luckyday_kurenotori_face.png) no-repeat left top;
    background-size: 28.13% auto;
    padding-left: calc( 28.13% + 8px );
    color: #32373f;
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 22px;
    min-height: 110px;
    @include mq('w375'){
      min-height: 150px;
    }
    @include mq('w580'){
      min-height: 214px;
      font-size: 16px;
      line-height: 28px;
      padding-left: calc( 28.13% + 24px );
    }
  }
  .notice {
    text-align: left;
    font-size: 12px;
    line-height: 18px;
    color: #656d78;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kurenotori/partials/BlockNextLuckyday.vue